/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';

import { I18n } from '@aws-amplify/core';
import { Button } from '@material-ui/core';
import logoTn from '../../assets/Logos/LogoTn.png';

class ErrorPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
				<img src={logoTn} style={{ objectFit: "contain", maxWidth: 250, marginBottom: 50 }} />
				<h1>
					{I18n.get('ERROR_PAGE_MESSAGE')}
				</h1>
			</div>

		)
	}
}

export default ErrorPage;
